import { render, staticRenderFns } from "./HorarioTabs.vue?vue&type=template&id=498585f0"
import script from "./HorarioTabs.vue?vue&type=script&lang=js"
export * from "./HorarioTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports